/**
 * @deprecated utils/fetcher.ts 로 이관되었으므로 더이상 사용하지 않습니다.
 * */
export type HttpMethod = 'GET' | 'POST' | 'PUT' | 'DELETE' | 'PATCH' | 'OPTIONS' | 'HEAD' | 'TRACE' | 'CONNECT';

/**
 * @deprecated utils/fetcher.ts 로 이관되었으므로 더이상 사용하지 않습니다.
 * */
export interface FetcherParams<U> {
  url: string;
  method: HttpMethod;
  data?: U;
  params?: U;
  baseUrl?: string;
  headers?: Record<string, string>;
  timeout?: number;
  withCredentials?: boolean;
  cache?: RequestCache;
}

/**
 * @deprecated utils/fetcher.ts 로 이관되었으므로 더이상 사용하지 않습니다.
 * */
export type FetcherType = <T, U = null>(params: FetcherParams<U>) => Promise<T>;

/**
 * @deprecated utils/fetcher.ts 로 이관되었으므로 더이상 사용하지 않습니다.
 * */
export class ResponseError extends Error {
  public statusCode: number;
  public response: string;

  constructor(statusCode: number, response: string, message?: string) {
    super(message || `Request failed with status ${statusCode}: ${response}`);
    this.statusCode = statusCode;
    this.response = response;
  }
}
